/**
 * Strings for what the operator's console changes live (admin-dashboard
 * §4.9-§4.10): features turned off, announcement banners, maintenance.
 */
import type { Dict } from './core';

export const cfgEn: Dict = {
  'cfg.off.voice': 'Voice is turned off by the admins right now.',
  'cfg.off.image_uploads': 'Image uploads are turned off by the admins right now.',
  'cfg.off.reactions': 'Reactions are turned off by the admins right now.',
  'cfg.off.message_edit': 'Editing messages is turned off by the admins right now.',
  'cfg.off.pins': 'Pins are turned off by the admins right now.',
  'cfg.off.search': 'Search is turned off by the admins right now.',
  'cfg.voiceEnded': 'Voice was turned off by the admins, so you left the voice channel.',
  'cfg.ann.dismiss': 'Dismiss',
  'cfg.ann.label': 'Announcement',
  'cfg.mt.warn': 'Maintenance starts at {time}. Voice and chat will pause for a while.',
  'cfg.mt.title': 'Neosocial is down for maintenance',
  'cfg.mt.body': 'We’re working on the servers. Your messages and settings are safe.',
  'cfg.mt.until': 'Expected back by {date}, {time}.',
  'cfg.mt.soon': 'We’ll be back soon.',
  'cfg.mt.retry': 'Check again',
  'cfg.mt.checking': 'Checking…',
  'cfg.signup.closedTitle': 'Sign-up is closed',
  'cfg.texts.rules': 'Community rules',
  'cfg.texts.terms': 'Terms',
  'cfg.texts.privacy': 'Privacy',
  'cfg.warn.title': 'A warning from the Neosocial team',
  'cfg.warn.body': 'Your account was warned for {category} ({severity}).',
  'cfg.warn.until':
    'It counts against your account until {date}. Following the rules keeps it from going further.',
  'cfg.warn.when': 'Given on {date}.',
  'cfg.warn.ok': 'I understand',
  'cfg.warn.sev.low': 'minor',
  'cfg.warn.sev.medium': 'serious',
  'cfg.warn.sev.high': 'very serious',
  'cfg.warn.cat.spam': 'spam',
  'cfg.warn.cat.harassment': 'harassment',
  'cfg.warn.cat.hate': 'hate speech',
  'cfg.warn.cat.violence': 'violence or threats',
  'cfg.warn.cat.sexual_content': 'sexual content',
  'cfg.warn.cat.impersonation': 'impersonation',
  'cfg.warn.cat.scam': 'a scam',
  'cfg.warn.cat.illegal': 'illegal content',
  'cfg.warn.cat.other': 'breaking the rules',
  // Console v2 (§3.3): what staff wrote when they closed a case about you
  'cfg.case.title': 'A message from the Neosocial team',
  'cfg.case.body': 'Our Safety team reviewed something involving your account and wrote to you:',
  'cfg.case.when': 'Sent on {date}.',
  'cfg.rename.title': 'Choose a new username',
  'cfg.rename.body':
    'The Neosocial team changed your username to {name} for now. Choose the username you want to use instead.',
  'cfg.rename.save': 'Save username',
  'cfg.rename.badPassword': 'That password isn’t right.',
  'cfg.mt.checked': 'Last checked at {time}.',
  'cfg.mt.staff':
    'Maintenance is on. Only staff can use the app right now; everyone else sees the maintenance screen.',
  'cfg.mt.staffSignIn': 'Staff sign-in',
  // server refusals (errors.ts)
  'ns.err.100034': 'This is turned off by the admins right now.',
  'ns.err.100035': 'Neosocial is down for maintenance. Try again soon.',
  'ns.err.100036': 'Sign-up is closed right now.',
  'ns.err.100037': 'This account is suspended.',
  'ns.err.100037.until': 'This account is suspended until {date}.',
  'ns.err.100038': 'This account is disabled.',
  'ns.err.100038.until':
    'This account is being deleted: it will be deleted for good on {date}. Ask the admins if this is a mistake.',
  'ns.err.100039': 'The admins have limited this for your account.',
  'ns.err.100039.until': 'The admins have limited this for your account until {date}.',
};
